import BalanceTooltip from "src/components/wallets/header/BalanceTooltip";

interface InfoIconProps {
  tooltip?: string;
  color?: string;
}

const InfoIcon = ({ tooltip, color = "#002035" }: InfoIconProps) => {
  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      style={{ cursor: tooltip ? "pointer" : "default" }}>
      <g clipPath="url(#clip0_232_11193)">
        <path
          d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 9H5.4V5.4H6.6V9ZM6.6 4.2H5.4V3H6.6V4.2Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_232_11193">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  // If no tooltip is provided, return just the icon without the tooltip wrapper
  if (!tooltip) {
    return icon;
  }

  // If tooltip is provided, wrap the icon with the tooltip
  return <BalanceTooltip message={tooltip}>{icon}</BalanceTooltip>;
};

export default InfoIcon;
